<template lang="pug">
  .filteroption(v-if="options.length > 0")
    .filterwrap
      .facet(@click="toggleVisibility" :class="{ isActive }") {{ $t(`Filter.${option}`) }} 
        .clear(v-if="hasActiveOptions" @click="clear") <img src="/img/svg/close.svg" alt="Schließen" class="svg" />
        template(v-else) <img :src="chevronImage" alt="Chevron" class="svg" />
      .options(v-if="isActive")
        .range(v-if="isNumeric")
          template(v-if="option == 'size'")
            <input type="text" v-model="numericMinInput" placeholder="Bitte Min-Wert eingeben" />
            <input type="text" v-model="numericMaxInput" placeholder="Bitte Max-Wert eingeben" />
          template(v-else="")
            <input type="text" v-model="numericInput" placeholder="Bitte Wert eingeben" />
          //- .min {{ rangeMin }}
          //- DoubleRangeSlider(
          //-   :key="maxQuantityRange"
          //-   :minThreshold="1"
          //-   :maxThreshold="maxQuantityRange"
          //-   :min="rangeMin" :max="rangeMax"
          //-   @update:min="value => rangeMin = Number(value)" 
          //-   @update:max="value => rangeMax = Number(value)"
          //- )
          //- .max {{ rangeMax }}
        template(v-else)
          template(v-if="option == 'color'")
            .list.colorgrid
              //- <input type="text" v-model="exclude" placeholder="Ausschlußliste. z.B. rot,grün" />
              .option(v-for="[ name, count, image ] in options" @click.prevent="toggleOption(name)" 
              :class="{ active: isChecked(name) }"
              :for="optionId(name)")
                <input :checked="isChecked(name)" type="checkbox" :id="optionId(name)" /> <label><img :src="getImageUrl(image)" :alt="name" :title="name == $t(name) ? name :`${name}/${$t(name)}`" /> </label>
          template(v-else)
            .list
              //- <input type="text" v-model="exclude" placeholder="Ausschlußliste. z.B. rot,grün" />
              .option(v-for="[ name, count ] in options" @click.prevent="toggleOption(name)" :for="optionId(name)")
                <input :checked="isChecked(name)" type="checkbox" :id="optionId(name)" /> <label>{{ name }} <span>{{ count }}</span></label> <!-- name+'/'+$t(name)+' ('+count+')' -->
        .meta 
          .clear(@click="clear") {{ $t(`Zurücksetzen`) }}
          .close(@click="toggleVisibility") 
            .btn {{ $t(`Schließen`) }}
</template>

<script>
function swapKeysAndValues(obj) {
  const swapped = Object.entries(obj).map(
    ([key, value]) => [value, key]
  );
  return Object.fromEntries(swapped);
}
function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
import DoubleRangeSlider from '@/components/DoubleRangeSlider.vue'
export default {
  props: {
    option: String,
    isNumeric: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DoubleRangeSlider
  },
  data: () => ({
    exclude: "",
    filter: [],
    rangeMin: 1,
    rangeMax: null,
    numericInput: null,
    numericMinInput: null,
    numericMaxInput: null,

  //   colorsMap: {
  //  "holzbraun":"wooden",
  //  "braun":"brown",
  //  "schwarz":"black",
  //  "weiß":"white",
  //  "gold":"gold",
  //  "beige":"beige",
  //  "rot":"red",
  //  "grün":"green",
  //  "blau":"blue",
  //  "silber":"silver",
  //  "transparent":"transparent",
  //  "chrom":"chrome",
  //  "gelb":"yellow",
  //  "grau":"grey",
  //  "orange":"orange",
  //  "rosa":"pink",
  //  "bunt":"multicolor",
  //  "lila":"purple",
  //  "kupfer":"copper",
  //  "cognac":"cognac",
  //  "dunkel":"dark",
  //  "mint":"mint",
  //  "bordeaux":"bordeaux",
  //  "türkis":"turquoise",
  //  "rost":"rust",
  //  "hell":"bright",
  //  "apricot":"apricot",
  //  "magenta":"magenta",
  //  "sepia":"sepia",
  //  "oliv":"olive",
  //  "blutorange":"blood-orange",
  //  "lachsfarben":"salmon",
  //  "neon":"neon",
  //  "pfirsich":"peach",
  //  "senf":"mustard",
  //  "crimson":"crimson",
  //  "blassgrün":"pale-green",
  //  "karamell":"caramel",
  //  "lavendel":"lavender",
  //  "aubergine":"eggplant",
  //  "blaugrau":"slate-blue",
  //  "mitternacht":"midnight",
  //  "ocker":"ochre",
  //  "cyan":"cyan",
  //  "jeans":"jeans",
  //  "lime":"lime",
  //  "pastell":"pastel",
  //  "veilchen":"violet"
  //   },
  }),
  methods: {
    getImageUrl(img) {
      return `https://imgbackend.kstarberlin.de/insecure/w:30/h:30/rt:fill/plain/local://${img}`;
    },
    toggleVisibility() {
      this.$store.commit('UPDATE_LIST_FILTER_ACTIVE_FACET', { activeFacet: !this.isActive ? this.option : null })
    },
    isChecked(option) {
      return this.filter.some(active => active === option);
    },
    optionId(name) {
      return `${this.option}-${name}`;
    },
    toggleOption(selection) {
      const selections = [ ...this.filter ];
      if (selections.some(active => active === selection)) {
        this.filter = [ ...selections.filter(active => active !== selection) ]
      } else {
        selections.push(selection)
        this.filter = selections;
      }
      this.$emit('api-search');
    },
    clear() {
      if(this.filter.length === 0) return
      this.filter = []
      this.numericInput = null
      this.numericMinInput = null
      this.numericMaxInput = null
      this.$emit('api-search');
    },
    updateRange() {
        if (this.rangeMin == this.rangeMax) {
          this.filter = [`= ${this.rangeMin}`]
        } else {
          this.filter = [
            `> ${this.rangeMin-1}`,
            `< ${this.rangeMax-1}`,
          ]
        }
    }
  },
  watch: {
    '$store.state.listFilter.selections': {
      handler: function (newVal) {
        if (newVal[this.option] == this.filter) return;
        this.filter = newVal[this.option] || []
      },
      deep: true
    },
    filter: {
      handler: function (val) {
        const update = {
          [this.option]: val,
        }
        const query = {
          ...this.$route.query,
        }
        Object.entries(update).map(([key, value]) => {
          if (value.length > 0) {
             query[key] =  encodeURIComponent(value.map(item => item).join(','))
          } else {
            delete query[key];
          }
        })
        this.$router.replace({ path: this.$route.path, query, })
        this.$store.commit('UPDATE_SELECTED_LIST_FILTER', { selections: {
          ...this.$store.state.listFilter.selections,
          ...update,
        } })
    } },
    exclude: function (val) {
      this.$store.commit('UPDATE_SELECTED_LIST_FILTER_EXCLUSIONS', { exclusions: {
          ...this.$store.state.listFilter.exclusions,
          [this.option]: this.excludeList,
        } })
    },
    maxQuantityRange: function (val) {
      this.rangeMax = val;
    },
    numericInput: debounce(function (newVal) {
      if (newVal) {
        this.filter = [`>= ${newVal}`]
      } else {
        this.clear()
      }
      this.$emit('api-search');
    }, 500),
    numericMinInput: debounce(function (newVal) {
      if (newVal) {
        if (newVal == this.numericMaxInput) {
          this.filter = [`= ${newVal}`]
        } else {
          this.filter = [
            `>= ${newVal}`,
          ]
          if(this.numericMaxInput) {
            this.filter.push(`<= ${this.numericMaxInput}`)
          }
        }
      } else {
        this.clear()
      }
      this.$emit('api-search');
    }, 500),
    numericMaxInput: debounce(function (newVal) {
      if (newVal) {
        if (newVal == this.numericMinInput) {
          this.filter = [`= ${newVal}`]
        } else {
          this.filter = [
            `<= ${newVal}`,
          ]
          if(this.numericMinInput) {
            this.filter.push(`>= ${this.numericMinInput}`)
          }
        }
      } else {
        this.clear()
      }
      this.$emit('api-search');
    }, 500),
  },
  mounted () {
    this.rangeMax = this.maxQuantityRange;
    this.filter = this.$store.state.listFilter.selections[this.option] || []
  },
  computed: {
	  chevronImage: function () {
		  return `/img/svg/chevron-${this.isActive ? "up" : "down"}.svg`;
	  },
    colors: function () {
       return this.$store.state.listFilter.colors
    },
    isActive: function() { return this.$store.state.listFilter.activeFacet === this.option },
    hasActiveOptions: function() { return this.filter.length > 0; },
    options: function() { 
        const facet = this.$store.state.listFilter.facets[this.option]
        if (facet) {
          const options = { ...this.$store.state.listFilter.facets[this.option] }
          if(this.option === "color") {
            return this.$store.state.listFilter.colors
              .map(e => [e.color, options[e.color], e.image])
              .filter(e => e !== undefined && e[1]);;
          } else {
            return Object.entries(options).sort((a, b) => b[1] - a[1]).filter(([value]) => value != 'none');
          }
        } else {
          return [];
        }
    },
    maxQuantityRange: function() {
      return Math.max(...Object.keys(this.options).map(i => Number(i)))
    },
    excludeList: function() {
      if(this.exclude == "") {
        return []
      }
      return this.exclude.split(",")
    }
  }
}
</script>

<style scoped lang="sass">
.svg
  width: 8px
  height: 8px
.isActive .clear .svg
    filter: invert(100%)
.range
  padding: 0 16px
  padding-left: 8px
  padding-bottom: 4px
  .min
    position: absolute
    top: 16px
    left: 16px
  .max
    position: absolute
    top: 16px
    text-align: right
    right: 8px
.filteroption
  display: inline-block
  margin: 0 8px 8px 0
.filterwrap
  position: relative
.facet
  display: inline-block
  padding: 4px 16px
  background: #fff /* #c00 red */
  border: 1px solid #aaa
  border-radius: 10px
  text-transform: lowercase
  color: #000
  cursor: pointer
  font-size: 1.2em
  &:hover
    background: #aaa
  &.isActive
    background: #c00
    color: #fff
    border-color: #c00
  .clear
    cursor: pointer
    display: inline-block
    float: right
    margin-left: 8px
    &:hover
      text-decoration: underline
.options
  text-transform: none 
  padding: 8px 16px
  border: 1px solid #333
  position: absolute
  top: 2rem
  left: 0
  display: block
  min-width: 200px
  background: #fff
  z-index: 500
.list
  overflow: auto
  max-width: 300px
  max-height: 8rem
  margin-top: -8px
  padding-top: 8px
  margin-right: -16px
  padding-bottom: 8px
.colorgrid
  margin-left: -8px
  margin-right: -16px
  .option
    float: left
    padding: 2px
    input
      display: none
    img
      border-radius: 30px
      box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px
      padding: 2px
      background: #fff
      border: 1px solid #ccc
      width: 30px
      height: 30px
      display: block
    &.active img
      border: 1px solid #111
.option:hover
  text-decoration: underline
.option input
  margin-right: 4px
  pointer-events: none
.option span
  opacity: .5
.meta
  border-top: 1px solid #333
  margin: -8px -16px
  margin-top: 0
  padding: 4px 8px
  display: flex
  flex-direction: row;
  flex-wrap: wrap;
.meta 
  div
    flex: 1;
  .clear
    display: inline-block
    padding: 4px 8px
    text-decoration: underline
  .close
    text-align: right
    .btn
      display: inline-block
      padding: 4px 8px
      background: #c00
      color: #fff
      cursor: pointer
      &:hover
          background: #333
</style>
